import styled from "styled-components";

export const MdorViewer = styled.div`
    text-align: center;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;

    .pdf-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
    }
    
    .pdf-document {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 100%;
        overflow-x: auto;
    }
    
    .react-pdf__Document {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .react-pdf__Page {
        margin: 10px 0;
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
    }
    
    .react-pdf__Page__canvas {
        max-width: 100%;
        height: auto !important;
    }
    
    .controls {
        position: fixed;
        right: 15px;
        top: 15px;
        z-index: 10;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    
    .zoom-btn {
        background-color: #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        border: none;
        font-size: 24px;
        border-radius: 100%;
        width: 40px;
        height: 40px;
        text-align: center;
        cursor: pointer;
        
        &:disabled {
            background-color: #bbbbbb;
            cursor: not-allowed;
        }
        
        &:focus {
            outline: none;
        }
    }
    
    /* Error message styling */
    .error-message {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 20px;
        
        p {
            color: #990d15;
            font-size: 18px;
            margin-bottom: 20px;
        }
        
        .login-button {
            background-color: #990d15;
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 16px;
            
            &:hover {
                background-color: #7d0a11;
            }
        }
    }
    
    .page-error {
        color: #990d15;
        padding: 20px;
        border: 1px solid #ffcccc;
        background-color: #fff5f5;
        margin: 10px 0;
        border-radius: 4px;
    }
    
    /* Loading indicator styling */
    .loading {
        color: #990d15;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;